<template>
  <router-link to="/">
    <img
      class="img-fluid"
      src="@/assets/logo-nexyo.png"
      alt="Nexyo"
    />
  </router-link>
</template>